import axios from "axios";
import {useToast} from "vue-toastification";
import router from "../../router";
import products from "./products";

function getHeaders() {
	let headers = {};
	let token = localStorage.getItem("token");
	let session_id = localStorage.getItem("session_id");
	if (session_id)
		//if session_id is present in local storage, then set it as a header
		headers["session_id"] = session_id;
	if (token) {
		headers["is_guest"] = 0;
		headers["Authorization"] = `Bearer ${token}`;
	} else {
		//if token is not present in local storage, then set is_guest to 1
		headers["is_guest"] = 1;
	}
	return headers;
}

function getDeliveryFee(state) {
	let totalWeight = state.carts.reduce(
		(acc, current) => acc + current.qty * current.weight,
		0
	);
	let fee = state.delivery_fees.find(
		(delivery_fee) => totalWeight <= delivery_fee.weight
	);
	if (!fee) {
		fee = state.delivery_fees[state.delivery_fees.length - 1];
	}
	console.log("TLW", totalWeight);
	console.log("fee", fee);
	return fee;
}

function getCart() {
	return new Promise(async (resolve, reject) => {
		try {
			let {data} = await axios.get(
				process.env.VUE_APP_API_URL + "/api/frontend/carts",
				{headers: getHeaders()}
			);
			resolve(data);
		} catch (error) {
			reject(error);
		}
	});
}

export default {
	namespaced: true,
	state: {
		carts: [],
		total: 0,
		tax: 0,
		sub_total: 0,
		openCart: false,
		coupon: null,
		total_before_coupon: 0,
		delivery_fees: [],
		delivery_fee: 0,
		warehouse_state_id: 0,
		modal_open: false,
		status: {
			cart: {
				loading: false,
				error: "",
			},
			quantity: {
				loading: false,
				error: "",
			},
			deleteCart: {
				loading: false,
				error: "",
			},
			coupon: {
				loading: false,
				error: "",
			},
			related_products: {
				loading: false,
				error: "",
			}
		},
	},
	getters: {
		getCarts: (state) => state.carts,
		status: (state) => state.status,
		getTax: (state) => state.tax,
		getSubtotal: (state) => state.sub_total,
		getTotal: (state) => state.total,
		openCart: (state) => state.openCart,
		coupon: (state) => state.coupon,
		TotalBeforeCoupon: (state) => state.total_before_coupon,
		GetDeliveryFee: (state) => state.delivery_fee,
		getWarehouseStateId: (state) => state.warehouse_state_id,
		getModalOpen: (state) => state.modal_open,
	},
	actions: {
		//fetching carts
		async fetchCart({commit}) {
			commit("setLoading", {dataName: "cart", status: true});
			try {
				let data = await getCart(); //fetches the cart
				console.log("Products In Cart", data.payload);
				commit("setCart", data.payload);
				commit("setLoading", {dataName: "cart", status: false});
				//we need to update total on initial Fetch
				commit("updateTotal");
			} catch (error) {
				commit("setLoading", {dataName: "cart", status: false});
			}
		},
		async addCoupon({commit}, coupon_code) {
			commit("setLoading", {dataName: "coupon", status: true});
			try {
				let {data} = await axios.post(
					process.env.VUE_APP_API_URL + "/api/frontend/apply-coupon",
					{coupon_code},
					{headers: getHeaders()}
				);
				console.log("Coupon Applied", data.payload);
				let response = await getCart(); //fetching the cart again
				commit("setCart", response.payload); //setting the cart
				commit("updateTotal"); //updating the total
				useToast().success("Coupon code applied successfully", {timeout: 3000});
				commit("setLoading", {dataName: "coupon", status: false});
			} catch (error) {
				useToast().error(error.response.data.message, {timeout: 3000});
				commit("setLoading", {dataName: "coupon", status: false});
			}
		},

		async removeCoupon({commit}, coupon_code) {
			commit("setLoading", {dataName: "coupon", status: true});
			try {
				let {data} = await axios.post(
					process.env.VUE_APP_API_URL + "/api/frontend/remove-coupon",
					{coupon_code},
					{headers: getHeaders()}
				);
				console.log("Coupon Revoked", data.payload);
				let response = await getCart();
				commit("setCart", response.payload);
				commit("updateTotal");
				commit("setLoading", {dataName: "coupon", status: false});
				useToast().success("Coupon code removed successfully", {timeout: 3000});
			} catch (error) {
				useToast().error(error.response.data.message, {timeout: 3000});
				commit("setLoading", {dataName: "coupon", status: false});
			}
		},

		//adding to cart
		async addToCart(
			{commit, rootGetters},
			{qty = 1, product_id, product_combination_id, price, warehouse_id}
		) {
			commit("setLoading", {dataName: "cart", status: true});
			commit("setLoading", {dataName: "related_products", status: true});
			
			let params = {
				product_id: product_id,
				unit_price: price,
				qty: qty,
				product_combination_id: product_combination_id,
				warehouse_id: warehouse_id,
			};
			let session_id = localStorage.getItem("session_id");
			if (session_id) {
				params["session_id"] = session_id;
			}
			try {
				let {data} = await axios.post(
					process.env.VUE_APP_API_URL + "/api/frontend/carts",
					params,
					{headers: getHeaders()}
				);
				console.log("Product Added in Cart", data.payload);
				// check in localstore for session id
				// if exist then do nothing else same in localstore
				console.log(
					"session",
					data.payload.session_id && !localStorage.getItem("session_id")
				);
				// if payload session id is present and localstorage session id is not present
				if (data.payload.session_id && !localStorage.getItem("session_id")) {
					localStorage.setItem("session_id", data.payload.session_id);
				}
				//checking if product is already in cart
				let checkIfProductExist = this.state.cart.carts.find(
					(cart) => cart.combination.id == product_combination_id
				);
				//if product is in cart then update quantity
				if (checkIfProductExist) {
					if (qty > 1) {
						checkIfProductExist.qty = checkIfProductExist.qty + parseInt(qty);
					} else {
						checkIfProductExist.qty++;
					}
					checkIfProductExist.total_price =
						checkIfProductExist.qty * checkIfProductExist.unit_price;
					commit("updateCart", checkIfProductExist);
					useToast().success("Product updated in cart", {timeout: 3000});
				} else {
					//if product is not in cart then add it
					commit("addToCart", data.payload);
					useToast().success("Product added in cart", {timeout: 3000});
				}
				commit("setModalOpen", true);
				commit("setLoading", {dataName: "cart", status: false});
				commit("setLoading", {dataName: "related_products", status: false});
				//we need to update total when product is adding/updating in cart
				// this.dispatch("orders/toggleModal", false);
				this.dispatch("orders/upateRelatedProduct", product_id);
				commit("updateTotal");
			} catch (error) {
				console.log(error.response.data.message);
				useToast().error(error.response.data.message, {
					timeout: 3000,
				});
				commit("setLoading", {dataName: "cart", status: false});
				commit("setLoading", {dataName: "related_products", status: false});
			}
		},

		async updateCart({state, commit}, {cart_id, product_id, quantity_type}) {
			commit("setLoading", {dataName: "quantity", status: true});
			//here we need to find the product and update the quantity.
			let product = {...state.carts.find((cart) => cart.product.id == product_id)}; //here am making clone of the object.
			let session_id = localStorage.getItem("session_id");
			let putData = {};
			if (product.qty == 1 && quantity_type == "desc") {
				//stopping if product quantity is 1 and user still want to decrease quantity.
				commit("setLoading", {dataName: "quantity", status: false});
				return;
			}
			if (product) {
				//if product is present in cart then update the quantity
				if (quantity_type == "inc") {
					product.qty++;
					putData = {product_id: product_id, unit_price: 100, qty: product.qty};
				} else if (quantity_type == "desc") {
					product.qty--;
					putData = {product_id: product_id, unit_price: 100, qty: product.qty};
				}
			}
			// if session id is present in local storage then set it in putData
			if (session_id) {
				putData["session_id"] = session_id;
			}
			try {
				let {data} = await axios.put(
					process.env.VUE_APP_API_URL + "/api/frontend/carts/" + cart_id,
					putData,
					{headers: getHeaders()}
				);
				console.log("Product Updated in Cart", data.payload);
				commit("updateCart", data.payload);
				commit("setLoading", {dataName: "quantity", status: false});
				commit("updateTotal");
				useToast().success("Product updated in cart", {timeout: 3000});
			} catch (error) {
				console.log(error);
				useToast().error("Error While Updating Products In Cart", {
					timeout: 3000,
				});
				commit("setLoading", {dataName: "quantity", status: false});
			}
		},

		async deleteCart({commit}, {cart_id, product_id}) {
			//for deleting a product we need to send product id along with quantity 0.
			commit("setLoading", {dataName: "deleteCart", status: true});
			try {
				let {data} = await axios.patch(
					process.env.VUE_APP_API_URL + "/api/frontend/carts/" + cart_id,
					{
						product_id: product_id,
						unit_price: 0,
						qty: 0,
						session_id: localStorage.getItem("session_id"),
					},
					{headers: getHeaders()}
				);
				console.log("Cart Deleted", data.payload);
				commit("deleteCart", data.payload);
				if (this.state.cart.carts.length == 0) {
					commit("clearCart");
				} else {
					commit("updateTotal");
				}
				useToast().success("Product removed from the cart", {timeout: 3000});
				commit("setLoading", {dataName: "deleteCart", status: false});
			} catch (error) {
				console.log(error);
				useToast().error("Error While Removing Products From Cart", {
					timeout: 3000,
				});
				commit("setLoading", {dataName: "deleteCart", status: false});
			}
		},
		clearCart({commit}) {
			commit("clearCart");
		},
		toggleCart({commit}) {
			commit("toggleCart");
		},
		setModalOpen({commit}, status) {
			if (router.currentRoute.value.name != "ProductDetail") {
				return;
			}
			commit("setModalOpen", status);
		},
	},
	mutations: {
		// state.products.find((product) => product.id == payload.id)
		addToCart: (state, product) => {
			state.carts.push(product);
			state.warehouse_state_id = product.warehouse_state_id;
			state.delivery_fees = product.delivery_fees;
		},
		toggleCart: (state) => {
			state.openCart = !state.openCart;
		},
		updateCart: (state, payload) => {
			let cart = state.carts.find((cart) => cart.id == payload.id);
			Object.assign(cart, payload);
		},
		updateTotal: (state) => {
			if (state.carts.length == 0) {
				return;
			}
			state.delivery_fee = getDeliveryFee(state).fee; //here we are getting the delivery fee from getDeliveryFee function.
			let total = state.carts.reduce((acc, current) => acc + current.total_price, 0);
			if (state.coupon) {
				state.total_before_coupon = total;
				total = total - 100;
			}
			state.sub_total = total;
			total = total + state.delivery_fee; //total is now including delivery fee.
			state.tax = (total * state.carts[0].tax.tax_rate) / 100; //calculating tax
			state.total = total + state.tax; //final total is including tax.
		},
		setCart: (state, payload) => {
			state.carts = payload;
			if (payload.length > 0) {
				state.coupon = payload[0].coupon;
				state.delivery_fees = payload[0].delivery_fees;
				state.warehouse_state_id = payload[0].warehouse_state_id;
			}
		},
		deleteCart: (state, payload) => {
			state.carts = state.carts.filter((cart) => cart.id != payload.id);
		},
		clearCart: (state) => {
			state.carts = [];
			state.total = 0;
			state.sub_total = 0;
			state.tax = 0;
			state.delivery_fee = 0;
			state.delivery_fees = [];
			state.total_before_coupon = 0;
			state.coupon = null;
			state.warehouse_state_id = 0;
		},
		setModalOpen: (state, status) => {
			console.log();
			state.modal_open = status;
		},
		setLoading: (state, {dataName, status}) => {
			state.status[dataName].loading = status;
		},
		setError: (state, {dataName, error}) => {
			state.status[dataName].error = error;
		},
	},
};
